export default __webpack_public_path__ + "static/spinner-706124a2c0232f216d635afea5234738.gif";